import { isSingleProjectPlan, type PlanKind } from '@/modules/account'
import { daysUntil } from '@/utils'
import type { Project } from './stores'

// Projects only expire on the single-project plan, where each project is
// bought individually. This is a billing/entitlement concern — distinct from
// the processing status in ./status, which tracks statement extraction.
const EXPIRING_SOON_DAYS = 7

export type ExpirationState = 'active' | 'expiringSoon' | 'expired'

export const getExpirationState = (
  project: Project | null,
): ExpirationState => {
  if (!project?.expiresAt) return 'active'

  const daysLeft = daysUntil(project.expiresAt)
  if (project.expired || daysLeft < 0) return 'expired'

  return daysLeft <= EXPIRING_SOON_DAYS ? 'expiringSoon' : 'active'
}

export const daysUntilExpiration = (project: Project | null) =>
  project?.expiresAt ? daysUntil(project.expiresAt) : Number.POSITIVE_INFINITY

export const isProjectDeletable = (
  project: Project | null,
  planKind?: PlanKind,
) => !isSingleProjectPlan(planKind) || Boolean(project?.expired)
